require([
	'jquery',
	'masonry',
	'isotope',
	'base/mbiImageSize'
], function(
	$,
	Masonry,
	Isotope,
	mbiImageSize
	// mbiMq
	) {

	'use strict';
	var iso = '';
	function initMasonry() {
			var elem = document.querySelector('.js_grid');
			iso = new Isotope( elem, {
			itemSelector: '.item',
			layoutMode: 'masonry',
			masonry: {
			  	  percentPosition: true,
				  itemSelector: '.item',
				  columnWidth: '.grid-sizer',
				  gutter: '.grid-gutter'
			  }
			});

			$(document).on('click', '.js_filter', function(){
				$('.filter').removeClass('is_active');
				$(this).addClass('is_active');
				var thing = $(this).attr('data-filter');
				if(thing == 'all') {
					iso.arrange({filter: '*'});
				} else {
					iso.arrange({filter: '.' + thing});
				}
			});
	}

	if ($(document).find('.js_grid').length > 0) {
		mbiImageSize.init();
		setTimeout(function(){
			initMasonry();
			iso.layout();
		},200);
	}

	$('.section-isotopeWithFilter .overlay').click(function(e) {
		e.preventDefault();
		e.stopPropagation();

		if ($('html').hasClass('touch') && !$(this).hasClass('is_active')) {

			$('.section-isotopeWithFilter .overlay').removeClass('is_active');
			$(this).addClass('is_active');

		} else {

			var $link = $(this).find('.link');
			if ($link.length) {
				window.location.href = $link.attr('href');
			}

		}
	});


});
define("root/Assets/Templates/Html/IsotopeWithFilter/Js/IsotopeWithFilter", function(){});

